module.exports = "<v-progress-bar [percentage]=progress [ngClass]=class></v-progress-bar> ";